/* istanbul ignore file */

export { ArticleChart as default } from "./ArticleChart";
